/**
 * Check-in choices the staff member makes on every order — where the device
 * is and who is checking orders in — remembered on this device so they don't
 * have to be picked again for the next customer. Appointment vs walk-in is
 * NOT remembered: it defaults to walk-in unless the order came from the Today
 * page's appointment button (components/Checkout.jsx checkInDefaults).
 *
 * Only these two staff fields are ever stored here. Nothing about the
 * customer (name, email, phone, address, cart) may be added: resetKioskSession
 * deliberately keeps this key when it wipes everything else, and a customer
 * field surviving that wipe is exactly the bug where one customer's details
 * were carried into the next order.
 */

const KEY = "fxry-staff-prefs";

const FIELDS = ["dropofflocation", "intake_person"];

/** Keep only the known fields, as short strings. */
const sanitize = (prefs) => {
  const clean = {};
  FIELDS.forEach((field) => {
    const value = prefs?.[field];
    if (typeof value === "string" && value.trim() !== "") {
      clean[field] = value.slice(0, 300);
    }
  });
  return clean;
};

export const loadStaffPrefs = () => {
  try {
    return sanitize(JSON.parse(localStorage.getItem(KEY)));
  } catch (error) {
    return {};
  }
};

export const saveStaffPrefs = (values) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(sanitize(values)));
  } catch (error) {
    console.error("[STAFF PREFS] Failed to save:", error);
  }
};
